import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, View, TouchableOpacity, Platform, Image } from 'react-native';
import { Input, Button, Text, Line, Icon, Colors } from '../components';
import ConsultationController from '../controllers/consultationController';
import { StringUtils } from '../utils';

class ConsultationStartSelectType extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  componentDidMount() {
    this.setState({ loading_online_providers: true }, async () => {
      let request_data = {
        practice_id: this.props.practice_id,
        partner_id: this.props.partner_id
      }

      let online_providers_data = await ConsultationController.getOnlineChatProviders(request_data);
      let online_live_providers = await ConsultationController.getOnlineLiveVideoProviders(request_data);

      console.log('online_live_providers', online_live_providers);
      console.log('online_chat_providers', online_providers_data);

      let available_providers      = online_providers_data.available_providers      || [];
      let available_provider_count = online_providers_data.avialable_provider_count || 0;
      let enable_chat_button       = available_provider_count > 0 ? true : false;

      let available_live_providers = online_live_providers.data && online_live_providers.data.avialable_provider_count ? online_live_providers.data.avialable_provider_count : 0;
      let enable_live_button       = available_live_providers > 0 ? true : false;

      this.setState({ loading_online_providers: false, enable_chat_button: enable_chat_button, available_providers: available_providers, enable_live_button: enable_live_button })
    });
  }

  render_start_chat_button = () => {
    let active_live_chats = this.props.pet_consults && this.props.patient_id && this.props.pet_consults[this.props.patient_id] && this.props.pet_consults[this.props.patient_id].chat && this.props.pet_consults[this.props.patient_id].chat > 0 ? true : false;
    let display_live_chat =  this.state.enable_chat_button ? true : false;
    let display_asyn_chat = !this.state.enable_chat_button ? true : false;

    if (active_live_chats) {
      display_live_chat = false;
      display_asyn_chat = true;
    }

    if (this.props.is_rechat && this.props.rechat_provider_id) {
      display_live_chat = false;
      display_asyn_chat = true;
    }

    return <View>

      { display_live_chat ? <TouchableOpacity style={styles.consultation_selection_container}
                                              onPress={ async () => {

                                                if (this.state.loading_start_chat) {
                                                  return;
                                                }

                                                let request_data = {
                                                  care_consultation_id: this.props.care_consultation_id,
                                                  client_id: this.props.client_id,
                                                  patient_id: this.props.patient_id,
                                                  partner_id: this.props.partner_id,
                                                  category: this.props.category,
                                                }

                                                this.setState({ loading_start_chat: true }, async () => {
                                                  let response             = await ConsultationController.startLiveChatCareConsultation(request_data);
                                                  let care_consultation_id = response && response.data && response.data.care_consultation && response.data.care_consultation._id ? response.data.care_consultation._id : '';

                                                  if (response && response.success && this.props.success_chat_action) {
                                                    this.props.success_chat_action(care_consultation_id)
                                                  }

                                                  this.setState({ loading_start_chat: false });
                                                });

                                              }}>
                              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                <View style={{ width: 48 }}>
                                  <Image style={{ height: 35, width: 35, tintColor: Colors.GREEN }} resizeMode='contain' source={ require('../assets/images/text-icon.png') } />
                                </View>
                                <Text style={{ fontWeight: '500', fontSize: 16 }}>{ 'Start a Live Chat' }</Text>
                              </View>
                              { this.state.loading_start_chat ? <Progress.CircleSnail size={25} indeterminate={true} color={ Colors.PRIMARY } />
                                                              : <Icon name='chevron-right' solid={true} size={15} color={'#cccccc'} /> }
                            </TouchableOpacity>
                          : null }

      { display_asyn_chat ? <TouchableOpacity style={styles.consultation_selection_container}
                                              onPress={ async () => {

                                                if (this.state.loading_start_chat) {
                                                  return;
                                                }

                                                let request_data = {
                                                  care_consultation_id: this.props.care_consultation_id,
                                                  client_id: this.props.client_id,
                                                  patient_id: this.props.patient_id,
                                                  partner_id: this.props.partner_id,
                                                  category: this.props.category,
                                                }

                                                if (this.props.rechat_provider_id) {
                                                  request_data['provider_id'] = this.props.rechat_provider_id;
                                                }

                                                this.setState({ loading_start_chat: true }, async () => {
                                                  let response             = await ConsultationController.startOfflineChatCareConsultation(request_data);
                                                  let care_consultation_id = response && response.data && response.data.care_consultation && response.data.care_consultation._id ? response.data.care_consultation._id : '';

                                                  if (response && response.success && this.props.success_chat_action && care_consultation_id) {
                                                    this.props.success_chat_action(care_consultation_id)
                                                  }

                                                  this.setState({ loading_start_chat: false });
                                                });

                                              }}>
                              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                <View style={{ width: 48 }}>
                                  <Image style={{ height: 30, width: 30, marginRight: 6, tintColor: Colors.PRIMARY }} resizeMode='contain' source={ require('../assets/images/text-icon.png') } />
                                </View>
                                <Text style={{ fontWeight: '500', fontSize: 16 }}>{ 'Start a Chat Session' }</Text>
                              </View>
                              { this.state.loading_start_chat ? <Progress.CircleSnail size={25} indeterminate={true} color={ Colors.PRIMARY } />
                                                              : <Icon name='chevron-right' solid={true} size={15} color={'#cccccc'} /> }
                            </TouchableOpacity>
                          : null }
      <Line />
    </View>
  }

  render_live_video_button = () => {
    let display_live_vid      = this.state.enable_live_button ? true : false;

    if (!display_live_vid) {
      return null;
    }

    return <TouchableOpacity style={styles.consultation_selection_container}
                             onPress={ () => {

                               if (this.state.loading_start_live) {
                                 return;
                               }

                               let request_data = {
                                 care_consultation_id: this.props.care_consultation_id,
                                 client_id: this.props.client_id,
                                 patient_id: this.props.patient_id,
                                 partner_id: this.props.partner_id,
                                 category: this.props.category,
                               }

                               this.setState({ loading_start_live: true }, async () => {
                                 let response             = await ConsultationController.startLiveVideoCareConsultation(request_data);
                                 let care_consultation_id = response && response.data && response.data.care_consultation && response.data.care_consultation._id ? response.data.care_consultation._id : '';

                                 if (response && response.success && this.props.success_chat_action && care_consultation_id) {
                                   this.props.live_video_action(care_consultation_id)
                                 }

                                 this.setState({ loading_start_live: false });
                               });
                             }}>
     <View style={{ flexDirection: 'row', alignItems: 'center' }}>
       <View style={{ width: 48 }}>
         <Image style={{ height: 30, width: 30, marginRight: 5, tintColor: Colors.GREEN }} resizeMode='contain' source={ require('../assets/images/video-icon.png') } />
       </View>
       <Text style={{ fontWeight: '500', fontSize: 16 }}>{ 'Start Live Video Session' }</Text>
     </View>
     { this.state.loading_start_live ? <Progress.CircleSnail size={25} indeterminate={true} color={ Colors.PRIMARY } />
                                     : <Icon name='chevron-right' solid={true} size={15} color={'#cccccc'} /> }
    </TouchableOpacity>
  }

  render() {
    let category_str          = StringUtils.keyToDisplayString(this.props.category);
    let active_video_consults = this.props.pet_consults && this.props.patient_id && this.props.pet_consults[this.props.patient_id] && this.props.pet_consults[this.props.patient_id].video && this.props.pet_consults[this.props.patient_id].video > 0 ? true : false;
    let display_video_btn     = !active_video_consults ? true : false;

    if (this.props.is_rechat) {
      display_video_btn = false;
    }

    return (
      <View style={styles.main_container}>

        <View style={{ alignItems: 'center', marginBottom: 25, marginTop: 10 }}>
          <Icon name='check-circle' solid={true} color={Colors.GREEN} size={45} />
          <Text style={{ fontSize: 16, marginTop: 10, textAlign: 'center', width: 280 }}>{ "We'd be happy to help you with your " + category_str + " question." }</Text>
          <Text style={{ fontSize: 16, marginTop: 25, fontWeight: 'bold' }}>What works best for you?</Text>
        </View>

        <Line />

        { this.render_start_chat_button() }

        { display_video_btn ? <TouchableOpacity
                                style={styles.consultation_selection_container}
                                onPress={ () => {
                                  this.props.schedule_video_action();
                                }}>
                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                  <View style={{ width: 48 }}>
                                    <Image style={{ height: 30, width: 30, marginRight: 5, tintColor: Colors.PRIMARY }} resizeMode='contain' source={ require('../assets/images/video-icon.png') } />
                                  </View>
                                  <Text style={{ fontWeight: '500', fontSize: 16 }}>{ 'Schedule a Video Session' }</Text>
                                </View>
                                <Icon name='chevron-right' solid={true} size={15} color={'#cccccc'} />
                              </TouchableOpacity>
                            : null }

        <Line hide={!display_video_btn} />

        { this.render_live_video_button() }

        <Line />

      </View>
    );
  }

}

const styles = StyleSheet.create({
  main_container: {
    paddingBottom: 20,
    paddingLeft: 20,
    paddingRight: 20,
  },
  consultation_selection_container: {
    paddingBottom: 25,
    paddingTop: 25,
    marginTop: 5,
    marginBottom: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
});

export default ConsultationStartSelectType
